// Format "HH:MM" (24h) → "H:MM AM/PM" (12h)
export const fmt12 = (t) => {
  if (!t || typeof t !== "string") return t;
  const parts = t.split(":");
  if (parts.length < 2) return t;
  const h = parseInt(parts[0], 10);
  const m = parts[1];
  if (isNaN(h)) return t;
  const ampm = h >= 12 ? "PM" : "AM";
  const hr = h % 12 || 12;
  return `${hr}:${m} ${ampm}`;
};
